import styled from 'styled-components';
import { Flex } from '@chakra-ui/react';

export const Container = styled.div`
  width: 100%;
  padding-top: 0;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  max-height: 600px;
  min-height: 200px;
  height: fit-content;
  position: relative;
  /* border: 1px solid red; */

  div.content {
    /* border: 1px solid red; */
    /* display: none; */
    max-height: 20rem;
  }
  .content {
    /* border: 1px solid red; */
    flex-shrink: 0;
    max-height: 320px;
    overflow: auto;
    height: fit-content;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    padding-right: 10px;
    /* scroll-snap-type: proximity; */
    scroll-snap-align: top;
    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
      border: 0;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
      background-color: transparent;
      background-color: #ddd;
      background-color: inherit;
      width: 0;
      border: 0;
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.colors.primary};
      border-radius: 3px;
      outline: 0 solid slategrey;
    }
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 24px;
  width: 100%;
  header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin-bottom: 10px;
    p.title {
      font-size: 14px;
      font-weight: bold;
      margin-right: 10px;
    }
    span {
      font-size: 12px;
      opacity: 0.7;
    }
  }
  p.content {
    font-size: 14px;
    width: 100%;
  }
  div.files {
    width: 100%;
    margin-top: 12px;
    > div.file {
      width: 100%;
      border-radius: 4px;
      background-color: ${({ theme }) => theme.colors.white};
      border: 1px solid ${({ theme }) => theme.colors.gray150};
      height: 44px;
      display: flex;
      align-items: center;
      padding: 0 17px;
      margin-bottom: 8px;
      transition: opacity 400ms ease-in, transform 250ms cubic-bezier(0.175, 0.885, 0.32, 1.275),
        margin 100ms ease-out;
      &:hover {
        opacity: 0.8;
      }
      &:active {
        opacity: 0.65;
        transform: scale(1.01);
      }
      color: ${({ theme }) => theme.colors[500]};
      p {
        margin-left: 8px;
        font-weight: 700;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          filter: brightness(0.9);
        }
      }
    }
  }
  div.images {
    display: flex;
    width: 100%;
    margin-top: 12px;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 14px;
    img {
      width: 95px;
      height: 95px;
      border-radius: 8px;
      opacity: 0.7;
      transition: margin 100ms ease, transform 220ms 5ms ease-out, opacity 400ms ease-in;
      &:hover {
        opacity: 1;
        margin: 0 8px;
        transform: scale(1.15);
      }
    }
  }
`;

export const SendContainer = styled.div`
  min-height: 100px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.gray300};
  background-color: ${({ theme }) => theme.colors[1300]};
  z-index: 2;
  display: flex;
  flex-direction: column;
  padding: 14px;
  padding-bottom: 0;
  margin-right: 10px;

  .send {
    /* border: 1px solid red; */
    color: '#7E225A';
    margin-bottom: 10px;
  }
  button {
    color: ${({ theme }) => theme.colors.tertiary};
    font-weight: 700;
    transition: all ease-out 300ms;
    display: flex;
    align-items: center;

    align-self: flex-end;
    &:hover {
      opacity: 0.8;
    }
    &:active {
      opacity: 0.4;
    }

    > svg {
      /* position: relative;
      top: 10px; */
      /* color: ${({ theme }) => theme.colors.tertiary}; */
      margin-right: 10px;
    }
  }
  .col {
    display: flex;
    width: 100%;
    align-items: flex-start;
    gap: 8px;
  }
  .uploadBtns {
    margin-top: 8px;
    padding-left: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      font-size: 14px;
      opacity: 0.8;
      color: ${({ theme }) => theme.colors[700]};
    }
  }
  textarea {
    border: 0;
    flex: 1;
    max-width: 100%;
    resize: none;
    padding: 4px;
    outline: 0;
    &:disabled {
      background-color: ${({ theme }) => theme.colors[1300]};
    }
  }
`;

export const ContainerCommentScroll = styled(Flex)`
  /* max-height: 20rem; */
  display: none;
  flex-direction: column;
  overflow-y: scroll;
  /* border: 1px solid red; */
  flex-shrink: 0;
  max-height: 320px;
  overflow: auto;
  height: fit-content;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  padding-right: 10px;
  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    border: 0;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    background-color: transparent;
    background-color: #ddd;
    background-color: inherit;
    width: 0;
    border: 0;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.primary};
    border-radius: 3px;
    outline: 0 solid slategrey;
  }
`;
